import React from 'react'
import { useAtomValue } from 'jotai'
import { css } from 'styled-system/css'
import { AnimatePresence, motion } from 'motion/react'
import {
  recipeAvailabilitiesAtom,
  recipesInBasketAtom,
} from '@mindfulchefuk/store/onboarding'
import { getBasketRecipesFromBasketIDs } from '@mindfulchefuk/onboarding/helpers'
import { useChooseRecipesContext } from '@mindfulchefuk/onboarding/context/ChooseRecipesContext/ChooseRecipesContext'
import { OnboardingCartDrawerRecipe } from '@mindfulchefuk/onboarding/components/OnboardingCartDrawer/OnboardingCartBasket/OnboardingCartDrawerRecipe'

export const OnboardingCartBasketRecipeList = () => {
  const recipeIdsInBasket = useAtomValue(recipesInBasketAtom)
  const recipeAvailabilities = useAtomValue(recipeAvailabilitiesAtom)

  const { isCartDrawerOpen } = useChooseRecipesContext()

  const recipesToDisplay = getBasketRecipesFromBasketIDs({
    recipeIdsInBasket,
    recipeAvailabilities,
  })

  if (!recipesToDisplay.length) {
    return null
  }

  return (
    <motion.ul
      className={css({
        listStyle: 'none',
        margin: 0,
        padding: 0,
      })}
    >
      <AnimatePresence>
        {recipesToDisplay.map((recipe, index) => (
          <OnboardingCartDrawerRecipe
            key={recipe.basketDisplayTitle}
            recipe={recipe}
            index={index}
            isCartDrawerOpen={isCartDrawerOpen}
          />
        ))}
      </AnimatePresence>
    </motion.ul>
  )
}
